
    import { defineComponent } from 'vue';
    import { getModule } from 'vuex-module-decorators';
    import SignageLayoutDetails from '../../components/signage/SignageLayoutDetails.vue';
    import TierLimit from '../../components/TierLimit.vue';
    import TierState, { ITierState } from '../../store/modules/tier';
    
    let tierState = {} as ITierState;
    
    export default defineComponent({
      name: 'Signage Template Details',
      data() {
        return {
        }
      },
    
      components: {
        SignageLayoutDetails,
        TierLimit
      },
    
      computed: {
            showTierCallout(): boolean {
                if(!tierState.orgTier.digitalSignageEnabled) {
                    return true;
                }
                return false;
            }
        },
    
      async created () {
        tierState = getModule(TierState);
    
        await tierState.fetchTier();
      }
    });
    